import { Icon, Spinner } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { PlanrPopover } from "modules/common/components/planr/popover/Popover";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { CompletionWarningList } from "./CompletionWarningList";
import popover from "../details/HeaderPopover.module.scss";
import styles from "./CompletionWarningsDialog.module.scss";
import { CompletionWarning } from "./force-completion";

interface CompletionWarningsButtonProps {
    /** стор карточки: список ошибок и его загрузка */
    store: {
        completionWarnings: CompletionWarning[];
        /** идёт загрузка списка — крутится индикатор */
        completionWarningsPending: number;
        loadCompletionWarnings: () => Promise<any>;
    };
    orderId: string;
    /** переход к месту ошибки */
    onNavigate: (link: string) => void;
}

/**
 * Шапка карточки договора: сколько ошибок мешает завершению. По клику — список по вкладкам,
 * пункт ведёт к месту ошибки. Ошибок нет — кнопки нет. Свой observer: шапка рисуется внутри Formik
 * и на изменения стора сама не перерисовывается
 */
export const CompletionWarningsButton = observer(({ store, orderId, onNavigate }: CompletionWarningsButtonProps) => {
    const [open, setOpen] = useState(false);
    const warnings = store.completionWarnings;
    const loading = store.completionWarningsPending > 0;

    if (!warnings.length) {
        return null;
    }

    return (
        <PlanrPopover
            isOpen={open}
            onInteraction={(next) => {
                setOpen(next);
                // данные мог поменять кто-то другой
                next && store.loadCompletionWarnings();
            }}
            placement="bottom-start"
            usePortal={true}
            content={
                <div className={popover.popover}>
                    <div className={popover.popoverHeader}>
                        <span className={popover.popoverTitle}>Ошибки в проекте</span>
                        <span className={popover.popoverHint}>мешают завершить договор · нажмите, чтобы перейти</span>
                        {loading && (
                            <span className={popover.popoverLoading}>
                                <Spinner size={12} /> обновляем
                            </span>
                        )}
                    </div>
                    <div className={popover.popoverBody}>
                        <CompletionWarningList
                            warnings={warnings}
                            orderId={orderId}
                            onNavigate={(link) => {
                                setOpen(false);
                                onNavigate(link);
                            }}
                        />
                    </div>
                </div>
            }
        >
            <PlanrButton
                type="danger"
                size="small"
                className={`${styles.counter} ${open ? "" : styles.counterPulse}`}
                aria-label="Ошибки, которые мешают завершить договор"
            >
                <Icon icon="warning-sign" size={12} className={styles.counterIcon} />
                Ошибок: {warnings.length}
            </PlanrButton>
        </PlanrPopover>
    );
});
